"use client";

import type { ColumnDef } from "@tanstack/react-table";

import { sharedColumns } from "@/components/listings-table/columns";
import { ListingMenuActions } from "@/components/listings-table/ListingMenuActions";
import { type ListingDetailedType } from "@/hooks/use-listings";

// Use any type to maintain compatibility with shared columns
// TODO: Fix this properly by standardizing the data queries

export const tenantColumns: ColumnDef<ListingDetailedType>[] = [
  ...sharedColumns.filter(
    (col) =>
      col.id !== "winningBidder" &&
      col.id !== "comments" &&
      col.id !== "status" &&
      col.id !== "reservePrice",
  ),
  {
    id: "actions",
    header: "",
    cell: ({ row }) => (
      <ListingMenuActions listing={row.original} userRole="tenant" />
    ),
  },
];

// Mobile-optimized columns for the Favorites view: show only Property and Highest Bid on small screens
export const tenantFavoritesColumns: ColumnDef<ListingDetailedType>[] = [
  ...sharedColumns
    .filter((col) =>
      ["property", "highestBid", "startingPrice", "bidCount"].includes(
        col.id as string,
      ),
    )
    .map((col) => {
      // Hide startingPrice, bidCount, and highestBid on small screens; keep only property visible
      if (
        col.id === "startingPrice" ||
        col.id === "bidCount" ||
        col.id === "highestBid"
      ) {
        return {
          ...col,
          meta: {
            ...(col as any).meta,
            headerClassName: "hidden sm:table-cell",
            cellClassName: "hidden sm:table-cell",
          },
        } as ColumnDef<ListingDetailedType>;
      }
      return col as ColumnDef<ListingDetailedType>;
    }),
  {
    id: "actions",
    header: "",
    cell: ({ row }) => (
      <ListingMenuActions listing={row.original} userRole="tenant" />
    ),
    meta: {
      // Keep actions visible on all breakpoints
      headerClassName: "text-right",
      cellClassName: "text-right",
    },
  },
];

// Mobile-optimized columns for the Bids view: show only Property and Actions on small screens
export const tenantBidsColumns: ColumnDef<ListingDetailedType>[] = [
  ...sharedColumns
    .filter((col) =>
      ["property", "highestBid", "startingPrice", "bidCount"].includes(
        col.id as string,
      ),
    )
    .map((col) => {
      // Hide startingPrice, bidCount, and highestBid on small screens; keep only property visible
      if (
        col.id === "startingPrice" ||
        col.id === "bidCount" ||
        col.id === "highestBid"
      ) {
        return {
          ...col,
          meta: {
            ...(col as any).meta,
            headerClassName: "hidden sm:table-cell",
            cellClassName: "hidden sm:table-cell",
          },
        } as ColumnDef<ListingDetailedType>;
      }
      return col as ColumnDef<ListingDetailedType>;
    }),
  {
    id: "actions",
    header: "",
    cell: ({ row }) => (
      <ListingMenuActions listing={row.original} userRole="tenant" />
    ),
    meta: {
      // Keep actions visible on all breakpoints
      headerClassName: "text-right",
      cellClassName: "text-right",
    },
  },
];
